if (!customElements.get('worth-featured-arrows')) {
  customElements.define(
    'worth-featured-arrows',
    class WorthFeaturedArrows extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = this.closest('.worth-featured-slider');
        if (!this.sliderComponent) return;

        this.updatePosition = this.updatePosition.bind(this);
        this.resizeObserver = new ResizeObserver(this.updatePosition);
        this.resizeObserver.observe(this.sliderComponent);

        const firstCardMedia = this.sliderComponent.querySelector('.slider__slide .card__inner');
        if (firstCardMedia) this.resizeObserver.observe(firstCardMedia);

        window.requestAnimationFrame(this.updatePosition);
        if (document.fonts?.ready) document.fonts.ready.then(this.updatePosition);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updatePosition() {
        const firstCardMedia = this.sliderComponent.querySelector('.slider__slide .card__inner');
        if (!firstCardMedia) return;

        const componentRect = this.sliderComponent.getBoundingClientRect();
        const mediaRect = firstCardMedia.getBoundingClientRect();
        const mediaCenter = mediaRect.top - componentRect.top + mediaRect.height / 2;

        this.style.setProperty('--worth-featured-arrow-center', `${mediaCenter}px`);
      }
    }
  );
}
